module.exports = __webpack_public_path__ + "img/login-page.8e0d6698.png";